// extracted by mini-css-extract-plugin
export var select = "_oj-0";